import { classifyEffect } from './effectClassification';

/**
 * SF-181 Component 4: owner-perspective (not attacker-perspective) beneficial/harmful split for
 * Active Effects surfaces (Magic, Throne). Derived directly from `effectClassification.ts`'s
 * existing attacker-perspective map rather than hand-authored as a second, independently
 * maintained 32-entry classification (CLAUDE.md's grep-for-duplicated-literal drift risk) — that
 * map's own doc comments already describe DEFENSE/BUFF entries as good-for-the-owner and DEBUFF
 * entries as bad-for-the-owner, so this is a strict re-labeling of the same three buckets, not an
 * independent judgment call.
 */
export function isEffectBeneficialToOwner(effectType: string): boolean {
  return classifyEffect(effectType) !== 'DEBUFF';
}
